import { cn } from '../../lib/cn';

interface MeshBackgroundProps {
  variant?: 'warm' | 'cool' | 'dark';
  intensity?: 'soft' | 'medium' | 'strong';
  withGrid?: boolean;
  withNoise?: boolean;
  className?: string;
}

export function MeshBackground({
  variant = 'warm',
  intensity = 'medium',
  withGrid = true,
  withNoise = false,
  className,
}: MeshBackgroundProps) {
  const variantClass =
    variant === 'warm' ? 'bg-mesh-warm' : variant === 'cool' ? 'bg-mesh-cool' : 'bg-mesh-dark';
  const opacityClass =
    intensity === 'soft' ? 'opacity-40' : intensity === 'strong' ? 'opacity-100' : 'opacity-70';

  return (
    <div
      aria-hidden
      className={cn('pointer-events-none absolute inset-0 overflow-hidden', className)}
    >
      <div className={cn('absolute inset-0', variantClass, opacityClass)} />
      {withGrid ? (
        <div className="absolute inset-0 grid-pattern opacity-60" />
      ) : null}
      {withNoise ? (
        <div className="absolute inset-0 bg-noise opacity-[0.04] mix-blend-overlay" />
      ) : null}
    </div>
  );
}
